export default [
    {
        'id': 0,
        'handle': 'note',
        'title': 'Note',
        'color': 'green darken-1'
    },
    {
        'id': 1,
        'handle': 'paypal',
        'title': 'Paypal',
        'color': 'red'
    },
    {
        'id': 2,
        'handle': 'invoice',
        'title': 'Invoice',
        'color': 'blue-grey darken-1'
    },
    {
        'id': 3,
        'handle': 'amazon',
        'title': 'Amazon',
        'color': 'blue'
    }
];


// WEBPACK FOOTER //
// ./app/routes/mail/data/labels.js